import "katex/dist/katex.min.css";

import Latex from "react-latex-next";
import type { FC } from "react";

import { AnswerPractice } from "components";

import type { IAssignmentResult } from "store/slices/topicPractice";

import { generalOptionText } from "utils/formatTextForAnalysis";
import { getTextForSelfEvaluationOption } from "utils/getTextForSelfEvaluationOption";
import { AssignmentPrompt } from "components/AssignmentPrompt";

/* jchWUrJ67yoyztmi6ad7 */

interface Props {
  assignmentResult: IAssignmentResult;
  toggleModals: (showQuestionAnalysisIndex: number | null) => void;
}

const ViceMoznostiNahore: FC<Props> = ({ assignmentResult, toggleModals }) => {
  const { assignment } = assignmentResult.assignment;
  if (assignment === undefined || assignment === null) return null;

  const isSelfEvaluation = assignment.scoring?.scoringMethod.scoringMethod === "sebeopravení";

  return (
    <>
      <AssignmentPrompt assignment={assignment?.assignment} />

      {assignment.assignment?.questions.map((question, index) => (
        <div key={index} className={"mt-20px"}>
          <Latex>{question.heading ?? ""}</Latex>

          <AnswerPractice
            key={`answer-${index}`}
            index={index}
            assignment={assignment}
            type={assignmentResult.answerVariants?.[index]}
            toggleModals={toggleModals}
            showBackOnSolution={true}
            userAssignmentId={assignmentResult.assignment.id}
          >
            {isSelfEvaluation
              ? getTextForSelfEvaluationOption(assignmentResult.selfEvalAnswers[index]?.status ?? "danger")
              : generalOptionText(assignmentResult.userAnswers[index])}
          </AnswerPractice>
        </div>
      ))}

      <div className="question mt-20px">
        <p
          dangerouslySetInnerHTML={{
            __html: assignment.assignment?.questionsText ?? "",
          }}
        ></p>
      </div>
    </>
  );
};

export default ViceMoznostiNahore;
